<template>
    <Sidebar
        width="374px"
        :defaultLayout="false"
        :visible="isCustomFields"
        :zIndex="8"
        :className="`customFieldSidebar ${props.compact ? 'customFieldSidebar--compact' : ''}`"
    >
        <template #head-left>
            <span class="font-weight-bold font-size-18">{{$t('CustomField.create_custom_field')}}</span>
        </template>
        <template #head-right>
            <img :src="closeBlueImage" alt="closeButton" class="cursor-pointer" @click="handleClose()"/>
        </template>
        <template #body>
            <CustomFieldSidebarComponent
                @customFieldStore="customFieldStores"
                @closeSidebar="handleCloseSidebar"
                :componentDetails="componentDetails && Object.keys(componentDetails).length ? componentDetails : {}"
                :pageInd="componentDetails && Object.keys(componentDetails).length ? 1 : 0"
                :customFieldObject="componentDetails && Object.keys(componentDetails).length ? customFieldObjects : {}"
                :isType="isType"
            />
        </template>
    </Sidebar>
</template>
<script setup>
    import { ref, watch } from 'vue';
    import Sidebar from '@/components/molecules/Sidebar/Sidebar.vue';

    //image
    const closeBlueImage = require("@/assets/images/svg/CloseSidebar.svg");
    // emit
    const emit = defineEmits(['customFieldStore','closeSidebar','handleClose']);

    const props = defineProps({
        componentDetail:{
            type:Object,
            default:() => {}
        },
        isCustomField:{
            type:Boolean,
            default:false
        },
        customFieldObject:{
            type:Object,
            default:() => {}
        },
        isType:{
            type:Boolean,
            default:false
        },
        compact:{
            type:Boolean,
            default:false
        }
    });

    //ref
    const componentDetails = ref(props.componentDetail);
    const isCustomFields = ref(props.isCustomField);
    const customFieldObjects = ref(props.customFieldObject);

    watch(() => props.isCustomField, (newVal) => {
        isCustomFields.value = newVal;
    });
    watch(() => props.componentDetail, (newVal) => {
        componentDetails.value = newVal;
    });
    watch(() => props.customFieldObject, (newVal) => {
        customFieldObjects.value = newVal;
    });
    const customFieldStores = (val,isEdit) => {
        emit('customFieldStore',val,isEdit);
    };
    const handleCloseSidebar = (val,pageIndex) => {
        emit('closeSidebar',val,pageIndex);
    };
    const handleClose = () => {
        emit('handleClose');
    };
</script>
<style>
.customFieldSidebar--compact .sidebar-head {
    height: 52px;
}

.customFieldSidebar--compact .sidebar-head .font-size-18 {
    font-size: 16px !important;
}

.customFieldSidebar--compact .custom_field_content.custom_field_content_field {
    height: calc(100% - 56px) !important;
}

.customFieldSidebar--compact .custom_field_wrapper {
    margin: 10px 14px !important;
    padding: 8px 12px !important;
}

.customFieldSidebar--compact .custom_field__wrapper-image {
    width: 15% !important;
}

.customFieldSidebar--compact .custom_field__wrapper-tittle h5 {
    line-height: 18px !important;
}

.customFieldSidebar--compact .custom_field__wrapper-tittle span {
    line-height: 17px !important;
}

.customFieldSidebar--compact .custom_field_content .ml-20px.mr-20px {
    margin-left: 14px !important;
    margin-right: 14px !important;
}

.customFieldSidebar--compact .custom_field-border {
    padding-top: 12px !important;
    margin-bottom: 12px !important;
}

.customFieldSidebar--compact .custom_field-border h4 {
    padding-bottom: 5px !important;
    line-height: 22px !important;
}

.customFieldSidebar--compact .formkit__form-wrapper .formkit-label,
.customFieldSidebar--compact .formkit__form-wrapper .formkit-legend {
    padding-bottom: 6px !important;
    font-size: 13px !important;
    line-height: 18px !important;
}

.customFieldSidebar--compact .formkit__form-wrapper .formkit-input {
    padding: 5px 6px !important;
}

.customFieldSidebar--compact .formkit__form-wrapper .formkit-outer {
    margin-bottom: 12px !important;
}

.customFieldSidebar--compact .formkit__form-wrapper .helpCheckbox .formkit-options {
    margin-bottom: 6px !important;
}

.customFieldSidebar--compact .custom_field-btn .formkit-outer {
    margin: 10px 0 !important;
}

.customFieldSidebar--compact .custom_field-btn .formkit-input {
    font-size: 14px !important;
    line-height: 20px !important;
    padding: 2px 12px !important;
}
</style>
